import * as React from "react"
import { snippetClickHandler } from "../../../../../utils/contentBuilderLib"
import CtxHeroSection from "../ctx-hero-section/CtxHeroSection"

const HeroMediaSection = ({ contentBuilder, imageVideo, location, hasGradient, heightPreset }) => {
  const style = {}
  const classList = ["heroMediaSection","contentBuilderSection",...(contentBuilder.preset?.classList ||[])]

  let video
  if (!imageVideo?.video.data && !imageVideo?.externalVideo) {
    // Pas de video
    if (!imageVideo?.image.data) {
      // Pas d'image
      console.warn("Hero media sans media !")
    } else {
      // Image seulement
      style.backgroundImage = `url(${imageVideo?.image.data.attributes.url})`
    }
  } else if (imageVideo?.video.data || imageVideo?.externalVideo) {
    // Video
    if (imageVideo?.video.data) {
      // Video interne
      video = imageVideo?.video.data
    } else {
      // Video externe
      video = imageVideo?.externalVideo.data
    }
  }
  return (
      <CtxHeroSection
        image={imageVideo?.image?.data?.attributes}
        imgSrc={imageVideo?.image?.data?.attributes.url}
        videoSrc={video?.attributes.url}
        hasGradient={hasGradient}
        heightPreset={heightPreset}
        classes={classList.join(" ")}
      >
        <div
          onClick={(e) => {
            return snippetClickHandler(e, location)
          }}
          dangerouslySetInnerHTML={{ __html: contentBuilder.html }}
        />
      </CtxHeroSection>
  )
}

export const name = "HeroMediaSection"

export const init = (componentData, pageContext, location) => {
  return (
    <HeroMediaSection
      key={componentData.id}
      contentBuilder={componentData.contentContentBuilder}
      imageVideo={componentData.imageVideo}
      location={location}
      hasGradient={componentData.hasGradient}
      heightPreset={componentData.heightPreset}
    />
  )
}

export default HeroMediaSection
